import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

export default function DialogConfirmarEliminar({ open, onClose, onConfirm, loading}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs" // Tamaño compacto ideal para confirmaciones
      fullWidth
    >
      {/* Título con un icono de advertencia */}
      <DialogTitle id="alert-dialog-title" sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
        <DeleteForeverIcon color="error" />
        <Typography variant="h6" component="span" fontWeight="bold">
          ¿Eliminar este registro?
        </Typography>
      </DialogTitle>

      {/* Contenido con la advertencia explícita */}
      <DialogContent>
        <DialogContentText id="alert-dialog-description" sx={{ color: 'text.primary' }}>
          Esta acción es permanente. Una vez eliminado el registro, <strong>no se podrán recuperar</strong> los datos asociados.
        </DialogContentText>
      </DialogContent>

      {/* Botones de acción */}
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={onClose} 
          variant="outlined" 
          color="inherit"
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color="error" 
          autoFocus 
          disabled={loading}
        >
          {loading ? 'Eliminando...' : 'Sí, eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}